import {API_BASE} from '../apiConfig';
import {AI_MATCH_NEWS_VERSION} from './aiMatchNewsVersion';

/**
 * Отметить на сервере, что игрок закрыл анонс ежедневной «Битвы с AI Claude
 * Opus» (см. AiMatchNewsModal): эта его редакция больше не покажется ни на
 * этом, ни на другом устройстве. Редакцию называет клиент — ту, что показал
 * (aiMatchNewsVersion.js): сборка из кэша с прежним временем матча текущую
 * редакцию закрыть не должна. В редаксе меню отмечает анонс само и сразу
 * (setAiMatchNewsSeen), поэтому ответ здесь не нужен.
 *
 * Ошибка сети сюда не пробрасывается: модалка уже закрыта, и ронять из-за
 * отметки нечего — в худшем случае анонс покажется еще раз в другой сессии.
 *
 * @returns {Promise<boolean>} записал ли сервер отметку
 */
export const markAiMatchNewsSeen = async () => {
  try {
    const res = await fetch(`${API_BASE}/users/me/ai-match-news/seen`, {
      method: 'POST',
      credentials: 'include',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({version: AI_MATCH_NEWS_VERSION}),
    });
    if (!res.ok) {
      throw new Error(`HTTP ${res.status}`);
    }
    return true;
  } catch (error) {
    console.error('[AiMatchNews] Не удалось сохранить отметку показа', error);
    return false;
  }
};
